import { render, staticRenderFns } from "./VMilestoneForm.vue?vue&type=template&id=2be03708&"
import script from "./VMilestoneForm.vue?vue&type=script&lang=js&"
export * from "./VMilestoneForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports